function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "messagesTitle"
}, "messages");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "MP_for_a_Week_Assets",
  transform: "translate(-558.000000, -1064.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Detailed_Icon_Messages",
  transform: "translate(558.000000, 1064.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-23",
  x: 0,
  y: 0,
  width: 180,
  height: 180
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-2",
  fill: "#D7D6DC",
  points: "56.8944 131.9608 123.6172 131.9608 123.6172 41.1324 56.8944 41.1324"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.80164,72.06396 L83.68244,72.06396 C82.07404,72.06396 80.76964,70.75996 80.76964,69.15156 C80.76964,67.54276 82.07404,66.23876 83.68244,66.23876 L110.80164,66.23876 C112.41004,66.23876 113.71404,67.54276 113.71404,69.15156 C113.71404,70.75996 112.41004,72.06396 110.80164,72.06396",
  id: "Fill-3",
  fill: "#878496"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.80164,83.71476 L68.57164,83.71476 C66.96284,83.71476 65.65924,82.41076 65.65924,80.80236 C65.65924,79.19316 66.96284,77.88956 68.57164,77.88956 L110.80164,77.88956 C112.41004,77.88956 113.71404,79.19316 113.71404,80.80236 C113.71404,82.41076 112.41004,83.71476 110.80164,83.71476",
  id: "Fill-5",
  fill: "#878496"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.80164,95.36516 L68.57164,95.36516 C66.96284,95.36516 65.65924,94.06116 65.65924,92.45276 C65.65924,90.84396 66.96284,89.53996 68.57164,89.53996 L110.80164,89.53996 C112.41004,89.53996 113.71404,90.84396 113.71404,92.45276 C113.71404,94.06116 112.41004,95.36516 110.80164,95.36516",
  id: "Fill-7",
  fill: "#878496"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.8944,131.9608 L123.6172,131.9608 L123.6172,41.1324 L56.8944,41.1324 L56.8944,131.9608 Z M124.4308,145.1548 L56.0804,145.1548 C53.2732,145.1548 50.9972,142.8784 50.9972,140.0712 L50.9972,40.5148 C50.9972,37.7072 53.2732,35.4316 56.0804,35.4316 L124.4308,35.4316 C127.2388,35.4316 129.5144,37.7072 129.5144,40.5148 L129.5144,140.0712 C129.5144,142.8784 127.2388,145.1548 124.4308,145.1548 L124.4308,145.1548 Z",
  id: "Fill-9",
  fill: "#373150"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.41648,138.48428 C93.41648,140.19068 92.03368,141.57348 90.32768,141.57348 C88.62168,141.57348 87.23888,140.19068 87.23888,138.48428 C87.23888,136.77828 88.62168,135.39548 90.32768,135.39548 C92.03368,135.39548 93.41648,136.77828 93.41648,138.48428",
  id: "Fill-11",
  fill: "#D7D6DC"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-12",
  fill: "#878496",
  points: "66.3784 120.822 99.9356 120.822 99.9356 104.2128 66.3784 104.2128"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-13",
  fill: "#373150",
  points: "95.28016 114.07376 92.72576 116.62816 92.67736 116.67656 85.00216 109.00136 87.60496 106.39856 92.67736 111.47096 102.87376 101.27416 105.47696 103.87696"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-14",
  fill: "#878496",
  points: "56.8944 60.01 123.6172 60.01 123.6172 41.1324 56.8944 41.1324"
}))));

var SvgDetailedIconMessages = function SvgDetailedIconMessages(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "180px",
    height: "180px",
    viewBox: "0 0 180 180",
    "aria-labelledby": "messagesTitle",
    role: "img",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "messagesTitle"
  }, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDetailedIconMessages, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/detailed-icon-messages.e8438872.svg";
export { ForwardRef as ReactComponent };